import React, { ReactElement, useContext } from 'react';
import styled from 'styled-components/macro';
import { FormsContext } from 'pages/Forms/context/FormsContext';
import Prompt from '../Prompt';
import QuestionHeader from '../QuestionHeader';
import RequiredSelector from './RequiredSelector';
import { IFromDraftCommonProps } from '../Question';
import { FormQuestionType } from '@televet/shared-types';

interface ICheckboxProps extends IFromDraftCommonProps {
  defaultValue: boolean;
}

const Checkbox = ({ index, prompt, defaultValue, isRequired, lastIndex }: ICheckboxProps): ReactElement => {
  const { dispatch } = useContext(FormsContext);

  const handleDefaultChange = (): void => {
    if (isRequired) {
      dispatch({ type: 'UPDATE_IS_REQUIRED_AT_INDEX', payload: { questionIndex: index, isRequired: !isRequired } });
    }
    dispatch({ type: 'TOGGLE_DEFAULT_AT_INDEX', payload: { questionIndex: index } });
  };

  const handleRequireAndDefault = (): void => {
    if (defaultValue) {
      handleDefaultChange();
    }
  };
  return (
    <>
      <QuestionHeader index={index} questionType={FormQuestionType.Checkbox} lastIndex={lastIndex} />
      <Prompt index={index} prompt={prompt} />
      <Default>
        Default answer: <input type="checkbox" checked={defaultValue} onChange={handleDefaultChange}></input>
      </Default>
      <div onClick={handleRequireAndDefault}>
        <RequiredSelector index={index} isRequired={isRequired} />
      </div>
    </>
  );
};

export default Checkbox;

const Default = styled.div`
  margin-top: 10px;
`;
